export default {
  EmptyData: "Chưa có tài sản",
  EmptyDataAndAddNew: "Chưa có tài sản nào trên hệ thống, thêm tài sản để quản lý",
  List: {
    FilterAll: "Tất cả tài sản",
    AddButton: "Thêm tài sản",
    ImportButton: "Nhập khẩu thêm mới",
    ImportButton2: "Nhập khẩu tài sản đang sử dụng",
    SearchPlaceHolder: "Nhập tên, mã tài sản để tìm kiếm",
    SearchPlaceHolderAssetType: "Tìm kiếm theo mã, tên loại tài sản",
    Search: "Tìm kiếm tài sản",
    ListAsset: "Danh sách tài sản",
    ListTree: "Danh sách cây",
    ListDetail: "Danh sách chi tiết",
    IncrementButton: "Ghi tăng tài sản",
    SearchAsset: "Tìm kiếm tài sản theo tên, mã tài sản,...",
  },
  ActionMulti: {
    Scan: "In mã vạch",
    Broken: "Đánh dấu hỏng",
    Schedule: "Lập lịch sửa chữa, bảo dưỡng",
    Lost: "Đánh dấu mất",
    ChangeManager: "Thay đổi người quản lý",
    Cancel: "Hủy tài sản",
    RequestLiquidation: "Đề nghị thanh lý",
    Liquidation: "Thanh lý",
    ChangeAssetLocation: "Thay đổi vị trí",
    CreateDocument: "Tạo văn bản",
    SendEmail: "Gửi Email",
    Delete: "Xóa",
    Transfer: "Điều chuyển",
  },

  ActionSingle: {
    lost: "Đánh dấu mất",
    cancel: "Hủy tài sản",
    Increment: "Ghi tăng",
  },

  Detail: {
    AddAssetTitle: "Thêm mới tài sản",
    AddTitle: "Ghi tăng tài sản",
    Quantity: "Số lượng",
    UnitManagement: "Đơn vị quản lý",
    Unit: "Đơn vị tính",
    AssetType: "Loại tài sản",
    AssetCode: "Mã tài sản",
    AssetName: "Tên tài sản",
    OrgPrice: "Nguyên giá",
    Price: "Đơn giá",
    Amount: "Thành tiền",
    AmountValue: "Giá trị",
    Specification: "Quy cách tài sản",
    Origin: "Nguồn gốc",
    RemainingAmount: "Giá trị còn lại",
    Serial: "Số serial",
    UserManagement: "Người quản lý",
    Provider: "Nhà cung cấp",
    PurchaseDate: "Ngày mua",
    WarrantyPeriodTime: "Thời gian bảo hành",
    WarrantyPeriodCondition: "Điều kiện bảo hành",
    WarrantyPeriod: "Hạn bảo hành",
    ExpiryDate: "Thời gian hiệu lực",
    Location: "Vị trí tài sản",
    Description: "Ghi chú",
    Status: "Tình trạng",
    ContractNumber: "Số hợp đồng",
    WarrantyStartDate: "Ngày bắt đầu bảo hành",
    WarrantyEndDate: "Ngày hết hạn bảo hành",
    WarrantyEndDateShort: "Hạn bảo hành",
    MaintenanceBegin: "Bắt đầu bảo dưỡng từ",
    IsPeriodicMaintenance: "Bảo dưỡng định kỳ",
    UseStartDate: "Ngày sử dụng",
    MaintenancePeridod: "Kỳ bảo dưỡng",
    MaintenanceLastedDate: "Lần bảo dưỡng gần nhất",
    MaintenanceNextDate: "Lần bảo dưỡng tiếp theo",
    UsedUser: "Nhân viên",
    EmployeePosition: "Vị trí công việc",
    UsedOrganizationUnit: "Đơn vị công tác",
    AllocationDate: "Ngày cấp phát",
    AllocationDateShort: "Ngày đưa vào SD",
    DepreciationDate: "Ngày bắt đầu khấu hao",
    DepreciationValue: "Giá trị khấu hao",
    AllocationAssetInformation: "Thông tin cấp phát tài sản",
    ReduceAssetInformation: "Thông tin thu hồi tài sản",
    AllocatedAsset: "Tài sản được cấp phát",
    ReducedAsset: "Tài sản được thu hồi",
    AllocatedTo: "Cấp phát cho",
    IsPermanentAsset: "Là tài sản cố định",
    LifeTime: "Thời gian khấu hao",
    AccumDepreciationAmount: "Khấu hao lũy kế",
    LifeTimeRemaining: "Thời gian còn lại",
    AllocationType: "Đã cấp phát cho",
    AllocatedDate: "Đã cấp phát ngày",
    UsedObject: "Đối tượng sử dụng",
    OrganizationUnit: "Đơn vị",
    RepresentativeID: "Người đại diện quản lý",
    AllocationTime: "Thời gian phân bổ",
    AllocationValue: "Giá trị phân bổ",
    NumberAllocationPeriod: "Số kỳ phân bổ",
    AllocationStartDate: "Ngày bắt đầu phân bổ",
    RemainingAllocationPeriod: "Số kỳ phân bổ còn lại",
    ValueAllocated: "Giá trị đã phân bổ",
    ValueAwaitingAllocation: "Giá trị còn chờ phân bổ",
    RemainQuantity: "Số lượng chưa sử dụng",
    RemainQuantityShort: "SL chưa sử dụng",
    EditWarning:
      "<{0}> - {1} đã phát sinh ngày <{2}>. Vui lòng xóa phát sinh ngày <{3}> trước khi sửa tài sản.",
    AssetIncreament: "Tài sản đã thực hiện ghi tăng, bạn vui lòng xóa tài sản.",
    StatisticalBy: "Thống kê theo",
    LocationCode: "Mã vị trí TS",
    ManagementUnitCode: "Mã ĐVQL",
  },

  AssetInfo: {
    LostAssetTitle: "Báo mất tài sản",
    TitleAsset: "Thông tin tài sản",
    AssetCode: "Mã tài sản",
    AssetName: "Tên tài sản",
    AssetType: "Loại tài sản",
    Serial: "Số seri",
    PurchaseDate: "Ngày mua",
    ReceivedDate: "Ngày đưa vào sử dụng",
    Specification: "Quy cách tài sản",
    Status: "Tình trạng tài sản",
    StatusShort: "Tình trạng",
    SeriaNumberAsset: "Quy cách tài sản",
    TitleInfoEmployee: "Thông tin nhân viên sử dụng",
    Employee: "Nhân viên",
    EmployeeJob: "Vị trí công việc",
    EmployeeOrganization: "Đơn vị công tác",
    TitleInfoOrganization: "Thông tin phòng ban sử dụng",
    Organization: "Phòng ban",
    OrganizationRepresent: "Người đại diện",
    TitleLostAsset: "Thông tin báo mất tài sản",
    LocationID: "Vị trí tài sản",
    LostDate: "Ngày báo mất",
    LostSeason: "Lý do mất",
    LostFile: "Tài liệu đính kèm",
    WarrantyPeriod: "Hạn bảo hành",
    RemainingAmount: "Giá trị còn lại",
    OrgPrice: "Giá trị tài sản",
    UserUse: "Người sử dụng",
    UsedOrganizationUnitID: "Đơn vị sử dụng",
    TitleInfoStatus: "Tình trạng tài sản",
    DepreciationDate: "Ngày đưa vào SD",
    RepairDate: "Ngày sửa chữa",
    MaintainDate: "Ngày bảo dưỡng",
    ExecuteUnit: "Đơn vị thực hiện",
    CurrentPosition: "Vị trí hiện tại",
    Quantity: "Số lượng",
    LocationName: "Vị trí tài sản",
  },

  //Đánh dấu mất
  DisposalAssetDetail: {
    title: "Đánh dấu mất tài sản",
    AssetDetail: "Thông tin tài sản",
    AssetCode: "Mã tài sản",
    AssetName: "Tên tài sản",
    AssetType: "Loại tài sản",
    PurchaseDate: "Ngày mua",
    Status: "Tình trạng",
    RemainingAmount: "Giá trị còn lại",
    Specification: "Quy cách tài sản",
    AllocationFor: "Cấp phát cho",
    EmployeeDetail: "Thông tin nhân viên sử dụng",
    UsedUser: "Nhân viên",
    EmployeePosition: "Vị trí công việc",
    UsedOrganizationUnit: "Đơn vị công tác",
    AllocationDate: "Ngày đưa vào SD",
    Location: "Vị trí tài sản",
    OrganizationDetail: "Thông tin phòng ban sử dụng",
    Organization: "Phòng ban",
    OrganizationRepresent: "Người đại diện",
    LocationID: "Vị trí tài sản",
    TitleByCodeDetail: "Thông tin ghi nhận tài sản đã mất",
    TitleByQuantityDetail: "Thông tin mất",
    TitleQuantityLost: "Số lượng đánh dấu mất",
    QuantityLost: "SL mất",
    LostAssetDate: "Ngày mất",
    LostQuantityAssetDate: "Ngày đánh dấu mất",
    Reason: "Lý do mất",
    Quantity: "Số lượng",
    MoneyAmount: "Số tiền",
    Attachment: "Tệp đính kèm",
    UserType: "Đối tượng sử dụng",
    EmployeeUse: "Nhân viên sử dụng",
    OrganizationUnitUse: "Đơn vị sử dụng",
    QuantityNotEmpty: "Số lượng hủy không được để trống.",
    QuantityError: "Số lượng mất phải nằm trong khoảng từ 1 đến ##0##.",
    WarningNotSelectDisposalAsset: "Phải chọn ít nhất 1 tài sản mất.",
    WarningQuantityGreaterThanZero: "Số lượng tài sản phải lớn hơn 0",
  },
  //Đánh dấu mất
  CancelAssetDetail: {
    Title: "Đánh dấu hủy tài sản",
    AssetDetail: "Thông tin tài sản",
    AssetCode: "Mã tài sản",
    AssetName: "Tên tài sản",
    AssetType: "Loại tài sản",
    PurchaseDate: "Ngày mua",
    Status: "Tình trạng",
    RemainingAmount: "Giá trị còn lại",
    Specification: "Quy cách tài sản",
    AllocationFor: "Cấp phát cho",
    EmployeeDetail: "Thông tin nhân viên sử dụng",
    UsedUser: "Nhân viên",
    EmployeePosition: "Vị trí công việc",
    UsedOrganizationUnit: "Đơn vị công tác",
    AllocationDate: "Ngày đưa vào SD",
    Location: "Vị trí tài sản",
    OrganizationDetail: "Thông tin phòng ban sử dụng",
    Organization: "Phòng ban",
    OrganizationRepresent: "Người đại diện",
    LocationID: "Vị trí tài sản",
    TitleDetail: "Thông tin ghi nhận tài sản đã hủy",
    Date: "Ngày hủy",
    Season: "Lý do hủy",
    Quantity: "Số lượng",
    MoneyAmount: "Số tiền",
    Attachment: "Tệp đính kèm",
    OrgAmount: "Giá trị tài sản",
    EmployeeName: "Người sử dụng",
    OrganizationName: "Đơn vị sử dụng",
    ValidateOccurenceDate: "Ngày hủy lớn hơn hoặc bằng ngày mua.",
    CancelAssetInfo: "Thông tin hủy tài sản",
    AssetLocation: "Vị trí tài sản",
    EmployeeUsing: "Nhân viên sử dụng",
    OrganizationUsing: "Đơn vị sử dụng",
    AssetStatus: "Tình trạng",
    AllocationType: "Đối tượng sử dụng",
    CancelDate: "Ngày đánh dấu hủy",
    QuantityCancel: "Số lượng hủy",
    QuantityCancel1: "SL hủy",
    QuantityCancelTitle: "Số lượng đánh dấu hủy",
    QuantityErrorZero: "Số lượng hủy phải khác 0",
    QuantityError: "Số lượng hủy không được lớn hơn số lượng",
    QuantityNotEmpty: "Số lượng hủy không được để trống.",
    ValidateOccurenceDateAllocationDate: "Số lượng hủy không được để trống.",
    ErrorDateBefor: "Ngày hủy phải lớn hoặc bằng ngày ##0##",
  },
  BrokenAssetDetail: {
    BrokenAssetDetail: "Đánh dấu hỏng tài sản",
    BrokenDetail: "Thông tin ghi nhận tài sản hỏng",
    BrokenInfo: "Thông tin hỏng",
    BrokenDate: "Ngày hỏng",
    BrokenReason: "Tình trạng",
    BrokenFile: "Tài liệu đính kèm",
    BrokenDescription: "Mô tả tình trạng",
    WarningMarkAssetIsBroken:
      "Cho phép xác nhận hỏng tài sản đối với các tài sản chưa sử dụng, đang sử dụng, báo hỏng.",
    WarningMarkAssetIsBroken2: (value) =>
      `Ngày xác nhận hỏng phải lớn hơn hoặc bằng ${value} của tài sản`,
    WarningIsNotEnter: "Ngày hỏng không được để trống",
    WarningQuantityGreaterThanZero: "Số lượng tài sản phải lớn hơn 0",
    WarningLeftQuantityGreaterThanZero: "Số lượng tồn của tài sản phải lớn hơn 0",
    WarningQuantityError: "Số lượng hỏng phải nằm trong khoảng từ 1 đến {0}",
  },
  BrokenAssetByQuantityDetail: {
    BrokenQuantity: "Số lượng hỏng",
    BrokenQuantityShort: "SL hỏng",
    BrokenReason: "Tình trạng",
    PleaseSelectAtLeatOneRecord: "Vui lòng chọn ít nhất một dòng để thực hiện đánh dấu hỏng.",
    WarningProcessDateSmallerThanPurchaseDate: "Ngày đánh dấu hỏng không được nhỏ hơn ngày mua.",
  },
  ChangeManager: {
    Title: "Thay đổi người quản lý tài sản",
    Employee: "Nhân viên",
    Date: "Ngày thay đổi",
    Reason: "Lý do",
    Subtitle: (value) => `Hãy chọn nhân viên quản lý mới cho ${value} tài sản đã chọn`,
  },
  LostBroken: {
    Search: "Tìm kiếm tài sản",
    LostTitle: "Báo mất",
    BrokenTitle: "Đánh dấu hỏng",
    Liquidation: "Báo thanh lý",
  },
  Liquidation: {
    Search: "Tìm kiếm tài sản theo tên, mã tài sản,...",
  },
  RequestLiquidationAssetDetail: {
    RequestTitle: "Đề nghị thanh lý tài sản",
    MultiRequestAssetTitle: "Đề nghị thanh lý hàng loạt",
    AssetDetail: "Thông tin tài sản",
    AssetCode: "Mã tài sản",
    AssetName: "Tên tài sản",
    AssetType: "Loại tài sản",
    PurchaseDate: "Ngày mua",
    Status: "Tình trạng",
    RemainingAmount: "Giá trị còn lại",
    Specification: "Quy cách tài sản",
    EmployeeDetail: "Thông tin nhân viên sử dụng",
    UsedUser: "Nhân viên",
    EmployeePosition: "Vị trí công việc",
    UsedOrganizationUnit: "Đơn vị công tác",
    AllocationDate: "Ngày đưa vào sử dụng",
    Location: "Vị trí tài sản",
    OrganizationDetail: "Thông tin phòng ban sử dụng",
    Organization: "Phòng ban",
    OrganizationRepresent: "Người đại diện",
    LocationID: "Vị trí tài sản",
    RequestTitleDetail: "Thông tin đề nghị thanh lý",
    RequestLiquidationDate: "Ngày đề nghị thanh lý",
    RequestLiquidationSeason: "Lý do đề nghị thanh lý",
    LiquidationDecision: "Quyết định thanh lý",
    LiquidationAmount: "Số lượng",
    LiquidationMoneyAmount: "Số tiền",
    RequestLiquidationAttachment: "Tệp đính kèm",
    RequestLiquidationEmplyee: "Người đề nghị thanh lý",
    RequestLiquidationAsset: "Tài sản đề nghị thanh lý",
    QuantityError: "Số lượng đề nghị thanh lý phải nằm trong khoảng từ 1 đến ##0##.",
    QuantityNotEmpty: "Số lượng đề nghị thanh lý không được để trống.",
    OccurenceDateMustBiggerThanPurchaseDate:
      "Ngày đề nghị thanh lý không được nhỏ hơn ngày phát sinh nghiệp vụ gần nhất ",
    QuantityErrorZero: "Số lượng thanh lý phải khác 0",
  },
  Schedule: {
    ValidateScheduleAssetStatus:
      "Chỉ được lập lịch với các tài sản chưa sử dụng, đang sử dụng, báo hỏng, đã hỏng",
    ValidateScheduleAssetStatusContinue:
      "Chỉ được lập lịch với các tài sản chưa sử dụng, đang sử dụng, báo hỏng, đã hỏng, bạn có muốn tiếp tục không?",
  },
  LiquidationAssetDetail: {
    title: "Thanh lý tài sản",
    RequestTitle: "Đề nghị thanh lý tài sản",
    MultiAssetTitle: "Thanh lý hàng loạt",
    MultiRequestAssetTitle: "Thông tin đề nghị thanh lý",
    AssetDetail: "Thông tin tài sản",
    LiquidationAssetInfo: "Thông tin thanh lý",
    ListAsset: "Danh sách tài sản",
    AssetCode: "Mã tài sản",
    AssetName: "Tên tài sản",
    AssetType: "Loại tài sản",
    PurchaseDate: "Ngày mua",
    Status: "Tình trạng",
    RemainingAmount: "Giá trị còn lại",
    Specification: "Quy cách tài sản",
    AllocationFor: "Cấp phát cho",
    EmployeeDetail: "Thông tin nhân viên sử dụng",
    UsedUser: "Nhân viên",
    EmployeePosition: "Vị trí công việc",
    UsedOrganizationUnit: "Đơn vị công tác",
    AllocationDate: "Ngày cấp phát",
    Location: "Vị trí tài sản",
    OrganizationDetail: "Thông tin phòng ban sử dụng",
    Organization: "Phòng ban",
    OrganizationRepresent: "Người đại diện",
    LocationID: "Vị trí tài sản",
    TitleDetail: "Thông tin thanh lý",
    LiquidationDate: "Ngày thanh lý",
    LiquidationSeason: "Lý do thanh lý",
    DisposalAssetDecision: "Quyết định thanh lý",
    LiquidationAmount: "Số lượng",
    LiquidationNumber: "Số lượng thanh lý",
    LiquidationNumberShort: "SL thanh lý",
    LiquidationReason: "Lý do thanh lý",
    LiquidationValue: "Giá trị thanh lý",
    RequestLiquidationNumber: "Số lượng đề nghị thanh lý",
    RequestLiquidationNumberShort: "SL đề nghị thanh lý",
    LiquidationMoneyAmount: "Giá trị thanh lý",
    LiquidationAttachment: "Tệp đính kèm",
    LiquidationEmplyee: "Người thanh lý",
    LiquidationAsset: "Tài sản thanh lý",
    QuantityError: "Số lượng thanh lý phải nằm trong khoảng từ 1 đến ##0##.",
    QuantityNotEmpty: "Số lượng thanh lý không được để trống.",
    QuantityErrorZero: "Số lượng thanh lý phải khác 0",
    QuantityError2: "Số lượng thanh lý không được lớn hơn số lượng",
  },
  ListTab: {
    GeneralInfo: "Thông tin chung",
    Warranty: "Thông tin bảo hành",
    Maintenance: "Thông tin bảo dưỡng",
    Managerment: "Đã cấp phát",
    Depreciation: "Thông tin khấu hao",
    Allocation: "Thông tin phân bổ",
    Process: "Quá trình sử dụng",
    DetailAssetStatus: "Chi tiết tài sản",
    MaintenanceHistory: "Lịch sử sửa chữa, bảo dưỡng",
    Attachments: "Tệp đính kèm",
    AssetHistory: "Lịch sử tồn kho",
    Other: "Thông tin khác",
  },
  GridProcessAsset: {
    OccurenceDate: "Ngày thực hiện",
    OccurrenceType: "Nghiệp vụ",
    AssetStatusID: "Tình trạng",
    LocationName: "Vị trí tài sản",
    EmployeeName: "Người sử dụng",
    UsedOrganizationUnitName: "Phòng ban sử dụng",
    RepresentativeName: "Người đại diện",
    ManagementUnitName: "Đơn vị quản lý",
    CreatedBy: "Người thực hiện",
    Description: "Ghi chú",
    Quantity: "Số lượng",
  },
  MaintenanceHistory: {
    OccurenceDate: "Ngày bắt đầu",
    OccurrenceType: "Nghiệp vụ",
    RepairFinishDate: "Ngày hoàn thành",
    Description: "Nội dung sửa chữa",
    ExpectedCost: "Chi phí dự kiến",
    ActualCost: "Chi phí thực tế",
    EmployeeName: "Người thực hiện",
    AccountObjectName: "Đơn vị sửa chữa/bảo dưỡng",
    Quantity: "Số lượng",
  },
  Attachment: {
    Name: "Tệp đính kèm",
    Size: "Dung lượng",
    Download: "Tải về",
    AddButton: "Thêm tài liệu",
    FormDetailTitle: "Thêm tài liệu đính kèm",
    ButtonAddAttachment: "Đính kèm",
    Close: "Hủy",
    WarrningWhenCancel: "Bạn có muốn hủy bỏ việc thêm tệp đính kèm cho tài sản không?",
  },
  /*
   * Resource form đánh dấu mất hàng loạt
   * pvduy 23/02/2021
   */
  MutilLostAssetDetail: {
    title: "Đánh dấu mất tài sản hàng loạt",
    Infor: "Thông tin chung",
    LostDate: "Ngày đánh dấu mất",
    LostSeason: "Lý do mất",
    Employee: "Người báo mất",
    Attachment: "Tệp đính kèm",
    LostAssetList: "Danh sách tài sản",
    Reason: "Lý do mất",
    ConfirmContinue:
      "Chỉ được đánh dấu mất với tình trạng chưa sử dụng, đang sử dụng, báo hỏng, đã hỏng, báo mất, đề nghị thanh lý. Bạn có chắc chắn muốn tiếp tục không?",
  },
  /*
   * Resource form đánh dấu hỏng hàng loạt
   * pvduy 24/02/2021
   */
  MutilBrokenAssetDetail: {
    title: "Đánh dấu hỏng tài sản hàng loạt",
    Infor: "Thông tin chung",
    BrokenDate: "Ngày đánh dấu hỏng",
    BrokenSeason: "Lý do hỏng",
    Employee: "Người đánh dấu hỏng",
    Attachment: "Tệp đính kèm",
    BrokenAsset: "Tài sản đánh dấu hỏng",
    Reason: "Lý do hủy",
    Description: "Mô tả tình trạng",
    ValidateAssetStatus:
      "Không được phép Đánh dấu hỏng tài sản có tình trạng khác Đang sử dụng, Chưa sử dụng, Báo hỏng",
    ValidateAssetStatusContinue:
      "Chỉ được phép đánh dấu hỏng tài sản Đang sử dụng, Chưa sử dụng, Báo hỏng. Bạn có chắc chắn muốn tiếp tục không?",
  },
  /*
   * Resource form hủy tài sản hàng loạt
   * pvduy 25/02/2021
   */
  MutilCancelAssetDetail: {
    title: "Hủy tài sản hàng loạt",
    Infor: "Thông tin báo hủy",
    Attachment: "Tệp đính kèm",
    CancelAsset: "Danh sách tài sản",
    Reason: "Lý do hủy",
    CancelDate: "Ngày đánh dấu hủy",
  },
  ReUseAssetDetail: {
    ReUseAssetDetail: "Đưa tài sản bảo dưỡng vào sử dụng lại",
    AssetInfo: "Thông tin tài sản bảo dưỡng vào sử dụng lại",
    ReUseDate: "Ngày đưa vào sử dụng lại",
    WarrantyEndDate: "Ngày kết thúc bảo dưỡng",
    EmployeeWork: "Nhân viên thực hiện",
    ActualCosts: "Chi phí thực tế",
    OrganizationUnitName: "Đơn vị sửa chữa",
    ReUseAssetMaintain: "Đưa tài sản sửa chữa vào sử dụng lại",
    WarningOccurenceDate1: "Ngày đưa vào sử dụng lại không được nhỏ hơn ngày mua.",
    WarningOccurenceDate2: "Ngày đưa vào kho không được nhỏ hơn ngày mua.",
    ErrorMessDateNotLessThan: "Ngày {0} xong không được nhỏ hơn ngày {1}",
    ErrorMessDateNotGreaterThan: "Ngày {0} xong không được lớn hơn ngày đưa về sử dụng.",
    Repair: "sửa chữa",
    Maitain: "bảo dưỡng",
    ReUseInValid: "Tài sản chưa được cấp phát chỉ có thể đưa về kho.",
  },
  PrintBarCode: {
    Title: "Chọn tài sản cần in mã vạch",
    SelectedPape: "Chọn Khổ giấy",
    SelectedAsset: "Chọn tài sản",
    Search: "Tìm kiếm tài sản",
    Filter: "Lọc theo",
    PageTypeTwoTem: "Khổ giấy 2 tem",
    PageTypeThreeTem: "Khổ giấy 3 tem",
    PageTypeFourTem: "Khổ giấy 4 tem",
    PageTypeA5: "Khổ giấy A5 tem (40 tem)",
    PageTypeA4: "Khổ giấy A4 tem (65 tem)",
  },
  ChangeAssetLocation: {
    Title: "Thay đổi vị trí tài sản",
    Reason: "Lý do",
    Date: "Ngày thay đổi",
    Subtitle: (value) => `Hãy chọn vị trí mới cho ${value} tài sản đã chọn`,
  },
  CustomField: {
    Empty: "Chưa có thông tin khác nào",
    Add: "Thêm thông tin",
  },
  Validate: {
    CheckReUse: "Chỉ được đưa vào sử dụng lại với tài sản Đang bảo dưỡng.",
    CheckLost:
      "Chỉ những tài sản có trạng thái khác: Chưa sử dụng, Đang sử dụng, Báo hỏng, Hỏng, Báo mất, Đề nghị thanh lý mới được thực hiện chức năng này.",
    CheckRequestLiquidation:
      "Chỉ những tài sản có trạng thái: Chưa sử dụng, Đang sử dụng, Hỏng mới được thực hiện chức năng này.",
    CheckLiquidation:
      "Chỉ những tài sản có trạng thái: Chưa sử dụng, Đang sử dụng, Báo hỏng, Hỏng, Đề nghị thanh lý mới được thực hiện chức năng này.",
    CheckRepair:
      "Chỉ những tài sản có trạng thái: Chưa sử dụng, Đang sử dụng, Báo hỏng, Hỏng, Đề nghị thanh lý mới được thực hiện chức năng này.",
    CheckMaintain:
      "Chỉ những tài sản có trạng thái: Chưa sử dụng, Đang sử dụng, Báo hỏng, Hỏng, Đề nghị thanh lý mới được thực hiện chức năng này.",
    CheckCancel:
      "Chỉ những tài sản có trạng thái: Chưa sử dụng, Đang sử dụng, Báo hỏng, Hỏng, Đề nghị thanh lý mới được thực hiện chức năng này.",
    CheckMultiDisposal:
      "Chỉ được đánh dấu mất với tình trạng: Chưa sử dụng, Đang sử dụng, Đã hỏng, Báo mất, Đề nghị thanh lý, Báo hỏng.",
    RequestLiquidation:
      "Chỉ những tài sản có trạng thái khác: Đã hủy; Đã mất; Đã thanh lý; Đề nghị thanh lý mới được thực hiện chức năng này.",
    Liquidation:
      "Chỉ những tài sản có trạng thái khác: Đã hủy; Đã mất; Đã thanh lý mới được thực hiện chức năng này.",
    ChangeLocationAndManagerment:
      "Chỉ những tài sản có trạng thái khác: Đã hủy; Đã mất; Đã thanh lý mới được thực hiện chức năng này.",
  },
  ReUse: {
    Title: "Thông tin đưa tài sản vào sử dụng",
    ToInventory: "Đưa vào kho",
    ToOrganization: "Đưa về bộ phận sử dụng",
    ReUseDate: "Ngày đưa vào sử dụng lại",
    IntoInventoryDate: "Ngày đưa vào kho",
    Executiver: "Người thực hiện",
    Location: "Vị trí tài sản",
    MaitainedDate: "Ngày bảo dưỡng xong",
    RepairedDate: "Ngày sửa chữa xong",
    CurPrice: "Chi phí thực tế",
    ContentMaintain: "Nội dung bảo dưỡng",
    ContentRepair: "Nội dung sửa chữa",
    AssetRepair: "Tài sản đang sửa chữa",
    AssetMaintain: "Tài sản đang bảo dưỡng",
  },
  WarringCustom: {
    NotParentManagementUnit: "Tài sản chỉ được cấp phát cho phòng ban ở cấp chi tiết nhất",
    NotParentLocation: "Tài sản chỉ được cấp phát cho vị trí tài sản ở cấp chi tiết nhất",
    NotEmployee: "Tài sản đã cấp phát cho nhân viên bắt buộc phải có nhân viên nhận cấp phát",
    NotAllocationDate:
      "Tài sản đã cấp phát bắt buộc phải có Ngày cấp phát và không được nhỏ hơn Ngày mua.",
    AllocationDateLessThanPurchaseDate: "Ngày bắt đầu phân bổ không được nhỏ hơn Ngày mua.",
    DepreciationDateLessThanPurchaseDate: "Ngày bắt đầu khấu hao không được nhỏ hơn Ngày mua.",
    PurchaseDateLessThanMaintenanceBegin:
      "Ngày bắt đầu bảo dưỡng không được phép nhỏ hơn Ngày mua.",
  },
  MaintainAssetByQuantity: {
    Title: "Bảo dưỡng",
    MaintainDate: "Ngày bảo dưỡng",
    MaintainOrganizationUnit: "Đơn vị bảo dưỡng",
    MaintainCost: "Chi phí dự kiến",
    MaintainQuantity: "Số lượng bảo dưỡng",
    AssetDetail: "Thông tin tài sản",
    AssetCode: "Mã tài sản",
    AssetName: "Tên tài sản",
    AssetType: "Loại tài sản",
    PurchaseDate: "Ngày mua",
    Specification: "Quy cách tài sản",
    AssetLocation: "Vị trí tài sản",
    AssetStatus: "Tình trạng",
    Quantity: "Số lượng",
    MaintainQuantityTitle: "SL bảo dưỡng",
    MaintainQuantityToltip: "Số lượng bảo dưỡng",
    MaintainContent: "Nội dung bảo dưỡng",
    EmployeeUsing: "Nhân viên sử dụng",
    OrganizationUsing: "Đơn vị sử dụng",
    OrganizationRepresent: "Người đại diện",
    MaintainInfo: "Thông tin bảo dưỡng",
    AllocationType: "Đối tượng sử dụng",
    ValidateOccurenceDate: "Ngày bảo dưỡng lớn hơn hoặc bằng ngày mua.",
    QuantityError: "Số lượng bảo dưỡng phải nằm trong khoảng từ 1 đến ##0##.",
    QuantityNotEmpty: "Số lượng bảo dưỡng không được để trống.",
    MaxCharacter: "Bạn chỉ được nhập tối đa ##0## ký tự.",
    QuantityNotValid:
      "Số lượng tài sản bảo dưỡng các dòng chi tiết không bằng tổng số lượng tài sản đem đi bảo dưỡng.",
    ChooseOneAsset: "Phải chọn ít nhất 1 tài sản bảo dưỡng.",
    ErrorAssetMaintain: "Chỉ được bảo dưỡng tài sản chưa sử dụng, đang sử dụng hoặc tài sản hỏng.",
    ErrorMaintainDateLessThanOccurenceDate:
      "Ngày bảo dưỡng không được nhỏ hơn ngày phát sinh nghiệp vụ gần nhất, tức ngày ##0##",
  },
  gridAssetBalance: {
    ManagementUnitName: "Đơn vị quản lý",
    ObjectUsed: "Đối tượng sử dụng",
    EmployeeName: "Nhân viên sử dụng",
    UsedOrganizationUnitName: "Phòng ban sử dụng",
    RepresentativeName: "Người đại diện nhận",
    Location: "Vị trí",
    AssetStatus: "Tình trạng",
    Quantity: "Số lượng",
  },
  gridAssetHistory: {
    LogTime: "Ngày",
    Description: "Nội dung",
    OpeningQuantity: "Tồn đầu",
    UpQuantity: "Tăng",
    DownQuantity: "Giảm",
    AssetStatus: "Tình trạng",
    ClosingQuantity: "Số tài sản tồn",
  },
  AssetIncrement: {
    title: "Ghi tăng tài sản",
    IncrementAssetInfor: "Thông tin ghi tăng",
    IncrementNumber: "Số lượng tăng",
    UnitPrice: "Đơn giá",
    Amount: "Thành tiền",
    Management: "Đơn vị quản lý",
    Manager: "Người quản lý",
    LocationAsset: "Vị trí tài sản",
    Note: "Ghi chú",
    ErrorQuantity: "Số lượng tài sản ghi tăng phải lớn hơn 0.",
  },
  ReUseAssetByQuantityDetail: {
    TitleRepair: "Đưa tài sản sửa chữa vào sử dụng lại",
    TitleMaintain: "Đưa tài sản bảo dưỡng vào sử dụng lại",
    ReUseAssetInfo: "Thông tin đưa tài sản vào sử dụng lại",
    StockAssetInfo: "Thông tin đưa tài sản vào kho",
    AssetDetail: "Thông tin tài sản",
    AssetCode: "Mã tài sản",
    AssetName: "Tên tài sản",
    AssetType: "Loại tài sản",
    PurchaseDate: "Ngày mua",
    Specification: "Quy cách tài sản",
    Stock: "Đưa vào kho",
    Department: "Đưa về bộ phận sử dụng",
    MaintainFinishDate: "Ngày bảo dưỡng xong",
    RepairFinishDate: "Ngày sửa chữa xong",
    ReUseDate: "Ngày đưa vào sử dụng lại",
    StockDate: "Ngày đưa vào kho",
    ActualCost: "Chi phí thực tế",
    Employee: "Người thực hiện",
    ContentRepair: "Nội dung sửa chữa",
    ContentMaintain: "Nội dung bảo dưỡng",
    AssetLocation: "Vị trí tài sản",
    RepairDate: "Ngày sửa chữa",
    MaintainDate: "Ngày bảo dưỡng",
    VendorService: "Nhà cung cấp dịch vụ",
    RepairQuantity: "SL sửa chữa",
    MaintainQuantity: "SL bảo dưỡng",
    RepairQuantity1: "Số lượng sửa chữa",
    MaintainQuantity1: "Số lượng bảo dưỡng",
    ReUseAssetTitileGrid: "Số lượng đưa vào sử dụng lại",
    ReUseQuantity: "SL đưa vào sử dụng lại",
    StockQuantity: "SL đưa vào kho",
    ReUseQuantity1: "Số lượng đưa vào sử dụng lại",
    StockQuantity1: "Số lượng đưa vào kho",
    AllocationType: "Đối tượng sử dụng",
    EmployeeUsing: "Nhân viên sử dụng",
    OrganizationUsing: "Đơn vị sử dụng",
    OrganizationRepresent: "Người đại diện",
    AssetStatus: "Tình trạng",
    WarningOccurenceDate: "##1## không được nhỏ hơn ##2##.",
    WarningOccurenceDate1: "##1## không được nhỏ hơn ngày mua.",
    WarningAssetUnUse: "Tài sản chưa được cấp phát chỉ có thể đưa vào kho.",
    QuantityError: "Số lượng đưa vào sử dụng lại phải nằm trong khoảng từ 1 đến ##0##.",
  },
  ToolTipViewType: {
    List: "Xem dạng danh sách",
    Detail: "Xem dạng chi tiết",
    Group: "Xem dạng nhóm",
  },
};
